import _ from "lodash";
import React from "react";
import UIModal from "UIComponents/UIModal";
import classes from "./QuestionLibrarySelectedFeed.scss";
import { Button, IconButton } from "@toddle-edu/ds-web";
import { CloseOutlined } from "@toddle-edu/ds-icons";
import QuestionCard from "../QuestionLibraryFeed/QuestionCard/QuestionCard";
import { getAssessmentViewQuestionsCountLabel } from "Worksheet/modules/WorksheetUtils";
import classNames from "classnames";

const QuestionLibrarySelectedFeed = props => {
  const {
    handleSelectedQuestionModal,
    t,
    selectedQuestions,
    addQuestionToSelection,
    onAddButtonClick,
  } = props;

  const selectedQuestionsCountlabel = getAssessmentViewQuestionsCountLabel({
    options: selectedQuestions,
    t,
    source: "selectedFeed",
  });

  const renderSelectedQuestions = () => {
    return _.map(selectedQuestions, item => {
      return (
        <QuestionCard
          libraryCardDetails={item}
          isFromSelectionFeed={true}
          addQuestionToSelection={addQuestionToSelection}
        />
      );
    });
  };
  const countLabelClass = classNames(classes.countLabel, "text-body-2");

  return (
    <UIModal
      isOpen={true}
      modalContent={classes.modalClass}
      onRequestClose={handleSelectedQuestionModal}
    >
      <div className={classes.selectedQuestionHeader}>
        <div className={classes.selectedQuestionHeaderContainer}>
          <div className={classes.selectedQuestionHeaderText}>
            {t("common:no_question_selected", {
              count: _.size(selectedQuestions),
            })}
          </div>
          <IconButton
            onClick={handleSelectedQuestionModal}
            icon={<CloseOutlined />}
            dsVersion="2.0"
            variant="neutral"
            type="plain"
            size="medium"
            _legacy_variant={"plain"}
            _legacy_size={"medium"}
          />
        </div>
        <div className={countLabelClass}>
          {selectedQuestionsCountlabel.join(", ")}
        </div>
      </div>

      <div className={classes.questionsContainer}>
        {renderSelectedQuestions()}
      </div>

      <Button
        dsVersion="2.0"
        variant="progressive"
        _legacy_variant="progressive"
        className={classes.addQuestionButton}
        onClick={onAddButtonClick}
        disabled={_.size(selectedQuestions) == 0}
        testId="question-library-add-to-worksheet"
      >
        {t("worksheet:add_questions_to_worksheet_with_count", {
          count: _.size(selectedQuestions),
        })}
      </Button>
    </UIModal>
  );
};

export default QuestionLibrarySelectedFeed;
